export const storeResources = Object.freeze({
  AUTH: 'auth',
  USER: 'user',
  TICKETS: 'tickets',
  ERRORS: 'errors',
  CONFIG: 'config',
  CHATS: 'chats',
  INVOICES: 'invoices',
  NOTIFICATIONS: 'notifications',
  VERIFICATION_REQUEST: 'verification_request',
  TICKET_TEMPLATES: 'ticketTemplates',
  THEME_MODE: 'themeMode',
  UI_MODE: 'uiMode',
});
